import { defaultTo, get } from 'lodash';

/**
 * 拼接素材切割後的資訊，由後端隨素材（bannerExtra.cropInfo）帶回：切成 cols x rows
 * 片、每片 cropWidth x cropHeight。素材本身的尺寸是切割前的總和，而
 * creativeValues 的 videoW/videoH 存的是切割後的單屏尺寸，兩者不能混用。
 */
export type CreativeCropInfo = {
  cols: number;
  rows: number;
  cropWidth: number;
  cropHeight: number;
};

const isPositiveNumber = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value) && value > 0;

/**
 * 由 cropInfo 還原切割前的素材尺寸。欄位缺漏或不是正數就回 undefined（沒有 cropInfo
 * 的舊素材也走這條），讓呼叫端自己決定要退回哪種判斷。
 */
export const getCropInfoCreativeSize = (
  creativeExtra: unknown
): { width: number; height: number } | undefined => {
  const cropInfo = get(creativeExtra, 'cropInfo') as
    | Partial<CreativeCropInfo>
    | undefined;
  const { cols, rows, cropWidth, cropHeight } = defaultTo(cropInfo, {});
  if (
    !isPositiveNumber(cols) ||
    !isPositiveNumber(rows) ||
    !isPositiveNumber(cropWidth) ||
    !isPositiveNumber(cropHeight)
  ) {
    return undefined;
  }
  return { width: cropWidth * cols, height: cropHeight * rows };
};

export const getCropInfoCreativeSizeText = (
  creativeExtra: unknown
): `${number} x ${number}` | undefined => {
  const cropSize = getCropInfoCreativeSize(creativeExtra);
  return cropSize ? `${cropSize.width} x ${cropSize.height}` : undefined;
};
